import appAxios from '..'
import {
  GET_LOCATION_GOAL,
  GET_LOCATION_GOALS,
  GET_LOCATION_ORGANIZATIONS,
  GET_LOCATION_RULES,
  GET_LOCATION_VOUCHERS,
} from '../constants'
import { RuleInfo, VoucherInfo } from '../types'
import {
  ApiResultGeneric,
  GetGoalData,
  GetGoalsData,
  GetOrganizationsData,
} from './types'

const getOrganizations = async (
  locationCode: string
): Promise<ApiResultGeneric<GetOrganizationsData> | null> => {
  try {
    const params = { locationCode: locationCode }
    const result = await appAxios.get<ApiResultGeneric<GetOrganizationsData>>(
      GET_LOCATION_ORGANIZATIONS,
      { params }
    )

    return result.data
  } catch (err: any) {
    if (err.response) return err.response.data
    return null
  }
}

const getGoals = async (
  locationCode: string,
  organizationId: string
): Promise<ApiResultGeneric<GetGoalsData> | null> => {
  try {
    const params = {
      locationCode: locationCode,
      organizationId: organizationId,
    }
    const result = await appAxios.get<ApiResultGeneric<GetGoalsData>>(
      GET_LOCATION_GOALS,
      {
        params,
      }
    )

    return result.data
  } catch (err: any) {
    if (err.response) return err.response.data
    return null
  }
}

const getGoal = async (
  locationCode: string,
  organizationId: string,
  goalId: string
): Promise<ApiResultGeneric<GetGoalData> | null> => {
  try {
    const params = {
      locationCode: locationCode,
      organizationId: organizationId,
      goalId: goalId,
    }
    const result = await appAxios.get<ApiResultGeneric<GetGoalData>>(
      GET_LOCATION_GOAL,
      {
        params,
      }
    )

    return result.data
  } catch (err: any) {
    if (err.response) return err.response.data
    return null
  }
}

const getVouchers = async (
  locationCode: string,
  organizationId: string,
  goalId: string
): Promise<ApiResultGeneric<VoucherInfo[]> | null> => {
  try {
    const params = {
      locationCode: locationCode,
      organizationId: organizationId,
      goalId: goalId,
    }
    const result = await appAxios.get<ApiResultGeneric<VoucherInfo[]>>(
      GET_LOCATION_VOUCHERS,
      {
        params,
      }
    )

    return result.data
  } catch (err: any) {
    if (err.response) return err.response.data
    return null
  }
}

const getRules = async (
  locationCode: string,
  organizationId: string,
  goalId: string
): Promise<ApiResultGeneric<RuleInfo[]> | null> => {
  try {
    const params = {
      locationCode: locationCode,
      organizationId: organizationId,
      goalId: goalId,
    }
    const result = await appAxios.get<ApiResultGeneric<RuleInfo[]>>(
      GET_LOCATION_RULES,
      {
        params,
      }
    )

    return result.data
  } catch (err: any) {
    if (err.response) return err.response.data
    return null
  }
}

const locationApi = {
  getOrganizations,
  getGoals,
  getGoal,
  getVouchers,
  getRules,
}

export default locationApi
